import { useEffect, useRef, useState } from 'react';

export const useExpandAnimation = <K extends HTMLElement>(expanded?: boolean) => {
  const [isExpanded, setExpanded] = useState(expanded);
  const isInitialMount = useRef(true);
  const contentRef = useRef<K>(null);

  const toggleExpanded = () => {
    if (isExpanded) {
      if (contentRef && contentRef.current) {
        const realHeight = contentRef.current.scrollHeight;
        contentRef.current.classList.add('overflow-hidden');
        contentRef.current.style.height = realHeight + 'px';
        requestAnimationFrame(() => {
          if (contentRef && contentRef.current) contentRef.current.style.height = 0 + 'px';
        });
        contentRef.current.addEventListener(
          'transitionend',
          () => {
            setExpanded(false);
          },
          { once: true },
        );
      }
    } else setExpanded(true);
  };

  useEffect(() => {
    if (isExpanded && contentRef && contentRef.current) {
      if (isInitialMount.current) {
        // On initial mount with expanded=true: show content immediately without animation
        isInitialMount.current = false;
        contentRef.current.classList.remove('h-0');
        contentRef.current.style.height = '';
        contentRef.current.classList.remove('overflow-hidden');
        return;
      }
      const realHeight = contentRef.current.scrollHeight;
      requestAnimationFrame(() => {
        if (contentRef && contentRef.current) contentRef.current.style.height = realHeight + 'px';
      });
      contentRef.current.addEventListener(
        'transitionend',
        () => {
          if (contentRef && contentRef.current) {
            contentRef.current.classList.remove('h-0');
            contentRef.current.style.height = '';
            contentRef.current.classList.remove('overflow-hidden');
          }
        },
        { once: true },
      );
    } else {
      isInitialMount.current = false;
    }
    isInitialMount.current = false;
  }, [isExpanded]);

  return { isExpanded, contentRef, toggleExpanded };
};
